var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner ai-dashboard" }, [
    _c(
      "div",
      { staticClass: "dashboard-stats" },
      _vm._l(_vm.statsCards, function(item) {
        return _c(
          "div",
          {
            key: item.label,
            staticClass: "section stat-card",
            class: item.cardClass
          },
          [
            _c("div", { staticClass: "stat-card__label" }, [
              _vm._v(_vm._s(item.label))
            ]),
            _c("div", { staticClass: "stat-card__value-row" }, [
              _c("span", { staticClass: "stat-card__value" }, [
                _vm._v(_vm._s(item.value))
              ]),
              _c("span", { staticClass: "stat-card__unit" }, [_vm._v("笔")])
            ])
          ]
        )
      }),
      0
    ),
    _c("div", { staticClass: "section dashboard-table-section" }, [
      _c(
        "div",
        { staticClass: "dashboard-table-toolbar" },
        [
          _c("div", { staticClass: "dashboard-table-toolbar__main" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "dashboard-search" },
              [
                _c("el-input", {
                  staticStyle: { width: "140px" },
                  attrs: {
                    clearable: "",
                    size: "mini",
                    placeholder: "任务编号"
                  },
                  nativeOn: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleSearch($event)
                    }
                  },
                  model: {
                    value: _vm.searchForm.taskNo,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "taskNo", $$v)
                    },
                    expression: "searchForm.taskNo"
                  }
                }),
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      remote: "",
                      clearable: "",
                      size: "mini",
                      placeholder: "供应商",
                      "remote-method": _vm.remoteSupplierMethod,
                      loading: _vm.supplierLoading
                    },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchForm.supplierId,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "supplierId", $$v)
                      },
                      expression: "searchForm.supplierId"
                    }
                  },
                  _vm._l(_vm.supplierOptions, function(item) {
                    return _c("el-option", {
                      key: item.supplierId,
                      attrs: {
                        label: item.supplierName,
                        value: item.supplierId
                      }
                    })
                  }),
                  1
                ),
                _c(
                  "el-select",
                  {
                    attrs: {
                      clearable: "",
                      size: "mini",
                      placeholder: "账单类型"
                    },
                    on: { change: _vm.handleSearch },
                    model: {
                      value: _vm.searchForm.billType,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "billType", $$v)
                      },
                      expression: "searchForm.billType"
                    }
                  },
                  _vm._l(_vm.billTypeOptions, function(item) {
                    return _c("el-option", {
                      key: item.code,
                      attrs: { label: item.label, value: item.code }
                    })
                  }),
                  1
                ),
                _c("el-date-picker", {
                  attrs: {
                    type: "daterange",
                    clearable: "",
                    size: "mini",
                    "value-format": "yyyy-MM-dd",
                    "start-placeholder": "周期开始日期起",
                    "end-placeholder": "周期开始日期止"
                  },
                  on: { change: _vm.handleSearch },
                  model: {
                    value: _vm.searchForm.billPeriod,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "billPeriod", $$v)
                    },
                    expression: "searchForm.billPeriod"
                  }
                }),
                _c(
                  "el-button",
                  { attrs: { size: "mini" }, on: { click: _vm.handleReset } },
                  [_vm._v("重置")]
                )
              ],
              1
            )
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  return _vm.$emit("create-task")
                }
              }
            },
            [_vm._v(" 新建对账任务 ")]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "dashboard-table-body" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "dashboard-table",
              attrs: {
                data: _vm.tasks,
                border: "",
                stripe: "",
                size: "mini",
                "header-cell-class-name": "dashboard-table__header"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "taskNo",
                  label: "任务编号",
                  "min-width": "130"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.canView
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.openTask(row)
                                  }
                                }
                              },
                              [_vm._v(" " + _vm._s(row.taskNo) + " ")]
                            )
                          : _c(
                              "span",
                              {
                                staticClass: "task-no",
                                class: {
                                  "task-no--invalidated": row.isInvalidated
                                }
                              },
                              [_vm._v(" " + _vm._s(row.taskNo) + " ")]
                            )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "supplier", label: "供应商", "min-width": "180" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "billType",
                  label: "账单类型",
                  "min-width": "90"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "fileName",
                  label: "文件名",
                  "min-width": "130",
                  "show-overflow-tooltip": ""
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "billingCycle",
                  label: "账单周期",
                  "min-width": "90"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "uploadTime",
                  label: "上传时间",
                  "min-width": "140"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: "账单金额",
                  "min-width": "110",
                  align: "right"
                }
              }),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "status-pill",
                            class: row.statusClass
                          },
                          [_vm._v(_vm._s(row.statusText))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "190", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.canView
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.openTask(row)
                                  }
                                }
                              },
                              [_vm._v(" 查看详情 ")]
                            )
                          : _vm._e(),
                        row.canInvalidate
                          ? _c(
                              "el-button",
                              {
                                staticClass: "invalidate-button",
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  loading:
                                    _vm.invalidatingTaskUuid === row.taskUuid
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleInvalidate(row)
                                  }
                                }
                              },
                              [_vm._v(" 作废 ")]
                            )
                          : _vm._e(),
                        !row.canView && !row.canInvalidate
                          ? _c("span", { staticClass: "action-disabled" }, [
                              _vm._v("-")
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "dashboard-pagination" },
        [
          _c("div", { staticClass: "dashboard-pagination__summary" }, [
            _vm._v(_vm._s(_vm.pageSummary))
          ]),
          _c("el-pagination", {
            attrs: {
              background: "",
              small: "",
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next",
              total: _vm.total
            },
            on: {
              "update:currentPage": function($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function($event) {
                _vm.currentPage = $event
              },
              "update:pageSize": function($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function($event) {
                _vm.pageSize = $event
              },
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard-table-title" }, [
      _c("i", { staticClass: "el-icon-s-order" }),
      _c("span", [_vm._v("最新对账任务")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }